import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';
import Login from "./auth/Login.vue";
import Register from "./auth/Register.vue";
import RegisterCode from "./auth/RegisterCode.vue";
import RegisterSuccess from "./auth/RegisterSuccess.vue";
import Restore from "./auth/Restore.vue";
import RestoreCode from "./auth/RestoreCode.vue";
import RestoreConfirm from "./auth/RestoreConfirm.vue";
import RestoreSuccess from "./auth/RestoreSuccess.vue";


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ComponentsAuth',
},
  __name: 'Auth',
  emits: ["resubscribePage"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const store = useStore();

const authMode = computed(() => store.state.auth.authMode);

const setAuthMode = (mode: string): void => {
  store.dispatch('auth/setAuthMode', mode);
};

const switchMode = (mode: string): void => {
  setAuthMode(mode);
};

const resubscribePage = (): void => {
  emit('resubscribePage');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (authMode.value === 'login' || authMode.value === null)
      ? (_openBlock(), _createBlock(Login, {
          key: 0,
          onSwitchMode: switchMode
        }))
      : _createCommentVNode("", true),
    (authMode.value === 'register')
      ? (_openBlock(), _createBlock(Register, {
          key: 1,
          onSwitchMode: switchMode
        }))
      : _createCommentVNode("", true),
    (authMode.value === 'registerCode')
      ? (_openBlock(), _createBlock(RegisterCode, {
          key: 2,
          onSwitchMode: switchMode
        }))
      : _createCommentVNode("", true),
    (authMode.value === 'registerSuccess')
      ? (_openBlock(), _createBlock(RegisterSuccess, {
          key: 3,
          onSwitchMode: switchMode,
          onResubscribePage: resubscribePage
        }))
      : _createCommentVNode("", true),
    (authMode.value === 'restore')
      ? (_openBlock(), _createBlock(Restore, {
          key: 4,
          onSwitchMode: switchMode
        }))
      : _createCommentVNode("", true),
    (authMode.value === 'restoreCode')
      ? (_openBlock(), _createBlock(RestoreCode, {
          key: 5,
          onSwitchMode: switchMode
        }))
      : _createCommentVNode("", true),
    (authMode.value === 'restoreConfirm')
      ? (_openBlock(), _createBlock(RestoreConfirm, {
          key: 6,
          onSwitchMode: switchMode
        }))
      : _createCommentVNode("", true),
    (authMode.value === 'restoreSuccess')
      ? (_openBlock(), _createBlock(RestoreSuccess, {
          key: 7,
          onSwitchMode: switchMode,
          onResubscribePage: resubscribePage
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})